import { works } from "@/mocks/works";
import SectionHeading from "./SectionHeading";

export default function Recommendations() {
  return (
    <section id="recommend" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="作品推荐"
          title="本期精选推荐"
          desc="从婚后同居到古风婚约，每一部都是同好反复安利的人气之作，附上真实评分与一句话入坑理由。"
        />

        <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {works.map((w) => (
            <article
              key={w.id}
              className="group flex flex-col overflow-hidden rounded-2xl bg-background-100 ring-1 ring-background-200/80 transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="relative h-64 w-full overflow-hidden md:h-72">
                <img
                  src={w.image}
                  alt={`《${w.title}》作品封面`}
                  className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-2.5 py-1 text-xs font-semibold text-foreground-700">
                  {w.year} 年
                </span>
                <span className="absolute right-3 top-3 flex items-center gap-1 rounded-full bg-primary-500 px-2.5 py-1 text-xs font-bold text-background-50">
                  <i className="ri-star-fill text-accent-300" aria-hidden="true"></i>
                  {w.rating.toFixed(1)}
                </span>
              </div>

              <div className="flex flex-1 flex-col p-5">
                <div className="flex flex-wrap items-center gap-2">
                  {w.tags.map((t) => (
                    <span key={t} className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs font-medium text-secondary-800">
                      {t}
                    </span>
                  ))}
                </div>
                <h3 className="mt-3 font-heading text-lg font-bold text-foreground-900">《{w.title}》</h3>
                <p className="mt-1 text-xs font-medium text-primary-600">{w.genre}</p>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{w.desc}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200/80 pt-3">
                  <span className="text-xs text-foreground-500">{w.votes.toLocaleString()} 人看过</span>
                  <button
                    type="button"
                    className="inline-flex cursor-pointer items-center gap-1.5 rounded-full bg-background-50 px-4 py-2 text-xs font-semibold text-primary-600 ring-1 ring-primary-200 hover:bg-primary-500 hover:text-background-50 transition-colors"
                  >
                    <i className="ri-add-line" aria-hidden="true"></i>
                    想看
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}